import { render, staticRenderFns } from "./ExpN_Details.vue?vue&type=template&id=88cd8144"
import script from "./ExpN_Details.vue?vue&type=script&lang=js"
export * from "./ExpN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports